import { render, staticRenderFns } from "./PassWord.vue?vue&type=template&id=1bad07b8&scoped=true"
import script from "./PassWord.vue?vue&type=script&lang=js"
export * from "./PassWord.vue?vue&type=script&lang=js"
import style0 from "./PassWord.vue?vue&type=style&index=0&id=1bad07b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bad07b8",
  null
  
)

export default component.exports